import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const DateRangeFilter = ({ onFilterChange, onExport }) => {
  const [selectedRange, setSelectedRange] = useState("7days");

  const dateRanges = [
    { id: "7days", label: "Last 7 Days", icon: "Calendar" },
    { id: "30days", label: "Last 30 Days", icon: "Calendar" },
    { id: "thisMonth", label: "This Month", icon: "CalendarDays" },
    { id: "lastMonth", label: "Last Month", icon: "CalendarDays" },
    { id: "custom", label: "Custom Range", icon: "CalendarRange" },
  ];

  const handleRangeChange = (rangeId) => {
    setSelectedRange(rangeId);
    onFilterChange(rangeId);
  };

  return (
    <div className="bg-card rounded-xl border border-border p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex-1">
          <h4 className="text-sm md:text-base font-caption font-semibold text-foreground mb-3">
            Filter by Date Range
          </h4>
          <div className="flex flex-wrap gap-2">
            {dateRanges?.map((range) => (
              <button
                key={range?.id}
                onClick={() => handleRangeChange(range?.id)}
                className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs md:text-sm font-caption font-semibold transition-base ${
                  selectedRange === range?.id
                    ? "bg-primary text-primary-foreground"
                    : "bg-muted text-muted-foreground hover:bg-muted/70"
                }`}
              >
                <Icon name={range?.icon} size={14} className="md:w-4 md:h-4" />
                <span>{range?.label}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
          >
            Export
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="RefreshCw"
            iconPosition="left"
            onClick={() => console.log("Refresh data")}
          >
            Refresh
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;
